import type { CustomizeTemplateData } from '@apps/card/types/stationeryTemplate.types';
import { getLocalStorage } from '@shared/core';

const LOCAL_STORAGE_STASH_KEY = 'ReplicateGenStash';

const stashCardTemplate = (template: CustomizeTemplateData) => {
  const ls = getLocalStorage();
  const data = JSON.stringify(template);
  ls.setItem(LOCAL_STORAGE_STASH_KEY, data);
};

const isTemplate = (value: unknown): value is CustomizeTemplateData => {
  if (!value || !Object.prototype.hasOwnProperty.call(value, 'template') || !Object.prototype.hasOwnProperty.call(value, 'format')) {
    return false;
  }

  const { format, template } = value as CustomizeTemplateData;

  switch (format) {
    case 'digital': {
      if (!template.themeId) {
        return false;
      }
      break;
    }

    // Every draft-backed format carries the same `MinimalRequiredTemplateDataForDraft`, so they
    // validate identically. A format missing from this switch falls to `default` and is rejected
    // on read — the stash still writes, so the failure looks like the request silently vanishing
    // during signup rather than like a validation error.
    case 'paper':
    case 'premiumDigital':
    case 'envelope': {
      return ['themeId', 'category', 'themeJSON'].every(key => Object.prototype.hasOwnProperty.call(template, key));
    }

    case 'concierge': {
      return ['id', 'shortName', 'longName', 'identifier', 'thumbnailUrl'].every(key => Object.prototype.hasOwnProperty.call(template, key));
    }

    default:
      return false;
  }
  return true;
};

const fetchStashedTemplate = (): CustomizeTemplateData | undefined => {
  const ls = getLocalStorage();
  const data = ls.getItem(LOCAL_STORAGE_STASH_KEY);

  if (data) {
    const json = JSON.parse(data);
    if (isTemplate(json)) {
      return json;
    }
  }

  return undefined;
};

export { stashCardTemplate, fetchStashedTemplate };
